(() => {
  'use strict';
  const desktop = window.matchMedia('(min-width: 990px)');
  const money = value => new Intl.NumberFormat('de-DE', {style:'currency',currency:'EUR'}).format(value / 100);
  const init = (scope = document) => scope.querySelectorAll('[data-mp-accessories]').forEach(root => {
    if (root.dataset.initialized) return;
    const form = document.getElementById(root.dataset.formId);
    if (!form) return;
    root.dataset.initialized = 'true';
    const rows = [...root.querySelectorAll('[data-accessory-row]')];
    const summary = root.querySelector('[data-accessory-summary]');
    const quantity = row => {
      const input = row.querySelector('[data-accessory-quantity]');
      const value = Math.max(1, Math.min(99, Math.floor(Number(input.value) || 1)));
      input.value = value;
      return value;
    };
    const variant = row => {
      const option = row.querySelector('[data-accessory-length], [data-accessory-variant]')?.selectedOptions[0];
      if (option) {
        row.dataset.variantId = option.value;
        ['price', 'available', 'peerId', 'peerAvailable'].forEach(key => row.dataset[key] = option.dataset[key] || '');
      }
      const id = window.MiniPowerTax?.getMappedVariantId?.(row.dataset.variantId);
      const available = id && (String(id) === row.dataset.variantId ? row.dataset.available === 'true' : String(id) === row.dataset.peerId && row.dataset.peerAvailable === 'true');
      const price = window.MiniPowerTax?.getVariantDisplayCents?.(row.dataset.variantId, Number(row.dataset.price)) ?? Number(row.dataset.price);
      return {id, available, price};
    };
    const sync = () => {
      let count = 0;
      rows.forEach(row => {
        if (row.dataset.accessoryPending === 'true') {
          const check = row.querySelector('[data-accessory-check]');
          check.checked = false; check.disabled = true;
          return;
        }
        const state = variant(row), check = row.querySelector('[data-accessory-check]');
        check.disabled = !state.available;
        if (!state.available || !desktop.matches) check.checked = false;
        row.classList.toggle('is-selected', check.checked);
        row.classList.toggle('is-unavailable', !state.available);
        row.querySelector('[data-accessory-unavailable]').hidden = !!state.available;
        row.querySelector('[data-accessory-price]').textContent = '+ ' + money(state.price);
        row.querySelectorAll('[data-accessory-step],[data-accessory-quantity]').forEach(control => control.disabled = !check.checked);
        if (check.checked) count += quantity(row);
      });
      form.classList.toggle('mp-has-accessories', count > 0);
      summary.textContent = '';
    };
    form.mpAccessoryCartItems = items => {
      if (!desktop.matches) return items;
      const extras = rows.filter(row => row.querySelector('[data-accessory-check]').checked).map(row => {
        const state = variant(row);
        if (!state.available) throw new Error('Das gewählte Zubehör ist momentan nicht verfügbar. Bitte prüfe deine Auswahl.');
        return {id:Number(state.id), quantity:quantity(row)};
      });
      return [...items, ...extras];
    };
    root.addEventListener('change', sync);
    root.addEventListener('click', event => {
      const control = event.target.closest('[data-accessory-step]');
      if (!control || control.disabled) return;
      const row = control.closest('[data-accessory-row]'), input = row.querySelector('[data-accessory-quantity]');
      input.value = quantity(row) + Number(control.dataset.accessoryStep);
      sync();
    });
    // The existing mapped cart handler composes these items with the set's cable configuration.
    // Fail closed if that handler is unavailable, rather than silently omitting selected accessories.
    form.addEventListener('submit', event => {
      if (form.classList.contains('mp-has-accessories') && !window.MiniPowerTax?.getMappedVariantId?.(form.querySelector('[name="id"]')?.value)) {
        event.preventDefault(); event.stopImmediatePropagation();
        summary.textContent = 'Die Produktauswahl wird geladen. Bitte versuche es erneut.';
      }
    }, true);
    document.addEventListener('mp:tax-role-changed', sync);
    document.addEventListener('mp:tax-content-ready', sync);
    desktop.addEventListener('change', sync);
    document.dispatchEvent(new CustomEvent('mp:tax-content-ready', {detail:{root}}));
    sync();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), {once:true}); else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();

